/**
 * arrayFilter is a fairly simple wrapper for default array.filter functionality that allows giving commands for filtering with an object
 *
 * This is handy when filtering commands can change during the runtime. This can happen for example when the user can change the
 * filtering rules for table.
 *
 *
 * @param {*} array
 * @param {*} filterRules
 */
export default function arrayFilter(targetArray, filterRules = false) {
    if (filterRules === false) {
        return targetArray.slice();
    }

    if (!Array.isArray(filterRules)) {
        filterRules = [filterRules];
    }

    return targetArray.filter(item => {
        return filtering(item, filterRules, 0);
    });
}

function filtering(item, filterRules, index) {
    if (filterRules[index] === undefined) return true;
    return filterRule(item, filterRules[index]) ? filtering(item, filterRules, index + 1) : false;
}

function filterRule(item, rule) {
    // If the whole rule is a function send the complete item into that function.

    if (typeof rule === "function") {
        return rule(item);
    }

    const itemVal =
        rule.key.includes(".") && rule.dotNotation !== false ? findValueFromTree(item, rule.key) : item[rule.key];

    // Set some default rules if they are missing.
    if (rule.rule === undefined) {
        rule = getDefaultRules(itemVal, rule);
    }

    if (typeof rule.rule === "function") {
        return notWrapper(ruleCUSTOM, itemVal, rule);
    }

    switch (rule.rule.toUpperCase()) {
        case "IS":
            return notWrapper(ruleIS, itemVal, rule);
        case "ISTYPE":
            return notWrapper(ruleISTYPE, itemVal, rule);
        case "EQUAL":
            return notWrapper(ruleEQUAL, itemVal, rule);
        case "BETWEEN":
            return notWrapper(ruleBETWEEN, itemVal, rule);
        case "LT":
            return notWrapper(ruleLT, itemVal, rule);
        case "LTEQ":
            return notWrapper(ruleLTEQ, itemVal, rule);
        case "GT":
            return notWrapper(ruleGT, itemVal, rule);
        case "GTEQ":
            // return ruleGTEQ(itemVal, rule.value, rule);
            return notWrapper(ruleGTEQ, itemVal, rule);
        case "INCLUDE":
            return notWrapper(ruleINCLUDE, itemVal, rule);
        default:
            return false;
    }
}

function notWrapper(ruleFunction, itemVal, rule) {
    if (rule.not === true) {
        return !ruleFunction(itemVal, rule);
    }
    return ruleFunction(itemVal, rule);
}
function ruleIS(itemValue, rule) {
    const value = rule.nonCaseSensitive === true && typeof itemValue === "string" ? itemValue.toUpperCase() : itemValue;

    if (Array.isArray(rule.value)) {
        return (
            rule.value.find(val => {
                if (rule.nonCaseSensitive === true && typeof val === "string") {
                    return val.toUpperCase() === value;
                }
                return val === value;
            }) !== undefined
        );
    }
    return value === rule.value;
}

function ruleEQUAL(itemValue, rule) {
    // eslint-disable-next-line
    return itemValue == rule.value;
}

function ruleBETWEEN(itemValue, rule) {
    if (typeof itemValue !== "number") {
        return false;
    }

    if (rule.includeLimits === true) {
        return itemValue >= rule.min && itemValue <= rule.max;
    }
    return itemValue > rule.min && itemValue < rule.max;
}

function ruleGT(itemValue, rule) {
    if (typeof itemValue !== "number") {
        return false;
    }
    return itemValue > rule.value;
}

function ruleLT(itemValue, rule) {
    if (typeof itemValue !== "number") {
        return false;
    }
    return itemValue < rule.value;
}

function ruleGTEQ(itemValue, rule) {
    if (typeof itemValue !== "number") {
        return false;
    }
    return itemValue >= rule.value;
}

function ruleLTEQ(itemValue, rule) {
    if (typeof itemValue !== "number") {
        return false;
    }
    return itemValue <= rule.value;
}

function ruleISTYPE(itemValue, rule) {
    return typeof itemValue === rule.value;
}

function ruleINCLUDE(itemValue, rule) {
    if (typeof itemValue === "number") {
        return false;
    }

    if (typeof itemValue === "string") {
        return itemValue.includes(rule.value);
    }
    if (Array.isArray(itemValue)) {
        return itemValue.find(val => val === rule.value) !== undefined;
    }

    if (typeof itemValue === "object") {
        if (rule.hasKey !== undefined && rule.hasValue === undefined) {
            return itemValue[rule.hasKey] !== undefined;
        }

        if (rule.hasKey !== undefined && rule.hasValue !== undefined) {
            return itemValue[rule.hasKey] !== undefined && itemValue[rule.hasKey] === rule.hasValue;
        }

        if (rule.hasKey === undefined && rule.hasValue !== undefined) {
            return Object.values(itemValue).find(val => val === rule.hasValue) !== undefined;
        }
    }
}

function ruleCUSTOM(itemValue, rule) {
    return rule.rule(itemValue);
}

function findValueFromTree(item, key) {
    function findValue(object, keys, depth) {
        if (object[keys[depth]] === undefined) {
            return object;
        }
        return findValue(object[keys[depth]], keys, depth + 1);
    }

    return findValue(item, key.split("."), 0);
}

function getDefaultRules(itemValue, rule) {
    switch (typeof itemValue) {
        case "boolean":
            rule.rule = "IS";
            if (rule.value === undefined) {
                rule.value = true;
            }
            return rule;
        case "string":
            rule.rule = "IS";
            return rule;
        case "number":
            rule.rule = "IS";
            return rule;
        default:
            return rule;
    }
}
